import { render, staticRenderFns } from "./FarmerReport.vue?vue&type=template&id=2b31134e&scoped=true"
import script from "./FarmerReport.vue?vue&type=script&lang=js"
export * from "./FarmerReport.vue?vue&type=script&lang=js"
import style0 from "./FarmerReport.vue?vue&type=style&index=0&id=2b31134e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b31134e",
  null
  
)

export default component.exports